import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";

import styles from "./CollapsableText.scss";

function CollapsableText({}) {
  return <div className={styles.container}></div>;
}

CollapsableText.propTypes = {
  hotel: PropTypes.array.isRequired,
};

export default pure(CollapsableText);
